import React, { useEffect, useMemo } from "react";
import CustomTable, { Column } from "../../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { ProjectResponse } from "../../../model/projectModel";
import { useManageProjectContext } from "../../../context/ManageProjectContext";
import moment from "moment";
import { useLoading } from "../../../context/LoadingContext";
// import { ArrowPathIcon } from "@heroicons/react/24/outline";

const ManageProject: React.FC = () => {
  const navigate = useNavigate();
  const { isLoading } = useLoading();
  const { project, setProjectFormType, getProjects } =
    useManageProjectContext();
  const [searchName, setSearchName] = React.useState<string>("");
  const [statusFilter, setStatusFilter] = React.useState<number>(0); // 0 = Active, 1 = Inactive
  const columns: Column<ProjectResponse>[] = [
    { header: "Client Name", key: "client-name", enableLink: false, path: "" },
    {
      header: "Project Name",
      key: "project-name",
      enableLink: true,
      path: "/manageproject/updateProject",
    },
    {
      header: "Project Start Date",
      key: "project-start-date",
      enableLink: false,
      path: "",
    },
    {
      header: "Project End Date",
      key: "project-end-date",
      enableLink: false,
      path: "",
    },
    { header: "Status", key: "status", enableLink: false, path: "" },
  ];

  const projectListData = useMemo(() => {
    return project
      ? project
          .filter((list) =>
            list["project-name"]
              .toLowerCase()
              .includes(searchName.toLowerCase()),
          )
          .map((item) => {
            return {
              ...item,
              "project-start-date": moment(item["project-start-date"]).isValid()
                ? moment(item["project-start-date"]).format("DD/MM/YYYY")
                : null,
              "project-end-date": moment(item["project-end-date"]).isValid()
                ? moment(item["project-end-date"]).format("DD/MM/YYYY")
                : null,
            };
          })
      : null;
  }, [project, searchName]);

  // useEffect(() => {
  //   getProjects();
  // }, []);
  useEffect(() => {
    getProjects(statusFilter);
  }, [statusFilter]);
  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleNavigation = (path: string | undefined, states: number) => {
    setProjectFormType("update");
    navigate(path ?? "", { state: { id: states } }); // Navigate to the specified path with state
  };

  // const refreshTable = () => {
  //   setSearchName("");
  // };

  return (
    <>
      {/* <button
        onClick={() => {
          setProjectFormType("create");
          navigate("/manageproject/createProject");
        }}
        className='flex items-center px-4 py-2 text-sm mb-3 bg-gray-800 text-white rounded-lg focus:outline-none hover:bg-gray-600'
      >
        Add Project
      </button> */}
      <CustomTable
        showFilter={false}
        columns={columns}
        idKeyName="project-id"
        data={projectListData ?? []}
        handleNavigation={handleNavigation}
      >
        <div className="max-w-4xl gap-x-6 gap-y-8 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ">
          <div>
            <label
              htmlFor="status"
              className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
            >
              Search By Project Name
            </label>
            <div className="mt-2">
              <input
                type="text"
                placeholder=""
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                className="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="status"
              className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
            >
              Status
            </label>
            <div className="mt-2">
              <select
                id="status"
                value={statusFilter}
                onChange={(e) => setStatusFilter(Number(e.target.value))}
                className="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                <option value={0}>Active</option>
                <option value={1}>Inactive</option>
              </select>
            </div>
          </div>
          {/* <div className='flex space-x-4'> */}
            {/* <button
            onClick={() => handleTableRefresh()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <MagnifyingGlassIcon className='h-5 w-5 text-white' />
          </button> */}
            {/* <button
              onClick={() => refreshTable()}
              className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
            >
              <ArrowPathIcon className='h-5 w-5 text-white' />
            </button> */}
          {/* </div> */}
        </div>
      </CustomTable>
    </>
  );
};

export default ManageProject;
